export default function ceilNumber(number) {
    return Math.ceil(number);
}


// WEBPACK FOOTER //
// ./src/filters/ceilNumber.js